import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetSimilarArticlesLoading, EGetSimilarArticlesActionType } from './types';

export const getSimilarArticlesLoading: () => TGetSimilarArticlesLoading =
  actionGenerator<EGetSimilarArticlesActionType.Loading>(EGetSimilarArticlesActionType.Loading);
